import { Modal, GridItem } from '@sainsburys-tech/luna-react'
import { Body1, Display3 } from '@sainsburys-tech/luna-typography'
import { IGuardingActivity } from '../../../types/GuardingActivity/IGuardingActivityType'
import getRelativeDate from '../../../utils/getRelativeDate'

interface GuardingActivityModalProps {
  open: boolean
  onClose: () => void
  guardingActivity: IGuardingActivity['guardingActivity']
}

const GuardingActivityModal = ({ open, onClose, guardingActivity }: GuardingActivityModalProps) => {

  const dateOfActivity= guardingActivity.activityDate ? new Date(`${guardingActivity.activityDate}.000Z`) : null
  const timeOfActivity= new Date(`${guardingActivity.activityDate}.000Z`) ?? null

  const date = getRelativeDate({dateTime:dateOfActivity ?? undefined, type:'date'})
  const time = getRelativeDate({dateTime:timeOfActivity ?? undefined, type:'time24'})
  return (
    <Modal
      open={open}
      handleClose={onClose}
      headingId="dialog-modal"
    >
      <GridItem className="ln-u-text-align-center ln-u-push-bottom" gutterSize="0">
        <Display3>{guardingActivity.guardingActivity}</Display3>
      </GridItem>

      <GridItem size={{ sm: '1/2' }} className="ln-u-push-bottom" gutterSize="0">
        <Body1>
          <strong>Name:</strong>
          <div>{guardingActivity.addedByName}</div>
        </Body1>
      </GridItem>
      <GridItem size={{ sm: '1/2' }} className="ln-u-push-bottom" gutterSize="0">
        <Body1>
          <strong>Status:</strong>
          <div>
            {guardingActivity.activityDate
              ? `Completed: ${date} at ${time}`
              : 'Completion date not set'}
          </div>
        </Body1>
      </GridItem>
      <GridItem size="1/1" className="ln-u-push-bottom" gutterSize="0">
        <Body1 className="ln-u-color-dark">
          <strong>Additional comments:</strong>
          <div>{guardingActivity.commentsOrObservations || 'No comments provided.'}</div>
        </Body1>
      </GridItem>
      <GridItem>
        <Body1><strong>Attached images:</strong></Body1>
      </GridItem>
      <div>
        <div>
          {guardingActivity.attachments && guardingActivity.attachments.length > 0 ? (
            guardingActivity.attachments.map((attachment) => (
              <GridItem size={{ sm: '1/2' }} key={attachment.id} gutterSize="0">
                <div className="ln-u-padding-bottom*2">
                  <img src={`${attachment.url}`}
                    alt="attachment"
                    style={{ width: '100%', height: '250px', objectFit: 'cover' }}
                  />
                  <a href={attachment.url} target="_blank" rel="noopener noreferrer"> View attachment</a>
                </div>
              </GridItem>
            ))
          ) : (
              <span className="ln-u-body-1 ln-u-push-left">No images attached.</span>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default GuardingActivityModal
